import { useVillageSearch } from "../hooks/useVillageSearch";
import type { VillageViewModel } from "../../../domain/contracts";

type VillageSearchBarProps = {
  villages: VillageViewModel[];
  onSelectVillage: (villageRef: string | null) => void;
  setPanTarget: (target: [number, number] | null) => void;
  setZoomTarget: (zoom: number | null) => void;
};

export function VillageSearchBar({ villages, onSelectVillage, setPanTarget, setZoomTarget }: VillageSearchBarProps) {
  const search = useVillageSearch(villages, onSelectVillage, setPanTarget, setZoomTarget);

  return (
    <div className="map-search-overlay">
      <div className="portal-search-wrap">
        <div className="portal-search">
          <input
            ref={search.inputRef}
            type="text"
            className="portal-search-input"
            placeholder="Search villages..."
            value={search.query}
            onChange={(e) => search.handleChange(e.target.value)}
            onFocus={() => search.setIsFocused(true)}
            onBlur={() => setTimeout(() => search.setIsFocused(false), 200)}
            onKeyDown={search.handleKeyDown}
          />
          {search.query ? (
            <button type="button" className="portal-search-clear" onClick={search.clearSearch} aria-label="Clear search">×</button>
          ) : null}
        </div>
        {search.showDropdown ? (
          <ul className="portal-search-dropdown" role="listbox">
            {search.results.map((result, index) => (
              <li
                key={result.village.id}
                role="option"
                aria-selected={index === search.activeIndex}
                className={`portal-search-item${index === search.activeIndex ? " is-active" : ""}`}
                onMouseEnter={() => search.setActiveIndex(index)}
                onMouseDown={() => search.commitResult(result.village)}
              >
                <strong>{result.village.title}</strong>
                <span>{result.village.township}</span>
              </li>
            ))}
          </ul>
        ) : null}
      </div>
    </div>
  );
}